/**
 * Allowed audio MIME types for file uploads.
 * This is the single source of truth - used by both client and server validation.
 */
export const ALLOWED_AUDIO_TYPES = [
  "audio/mpeg",
  "audio/mp3", // Some mobile browsers report MP3 as audio/mp3
  "audio/mp4",
  "audio/x-m4a",
  "audio/aac",
  "audio/wav",
  "audio/x-wav",
  "audio/wave",
  "audio/vnd.wave", // The IANA-registered WAV type (RFC 2361); iOS reports this
  "audio/ogg",
  "audio/webm",
] as const;

/**
 * Maximum file size for audio uploads (50MB).
 */
export const MAX_AUDIO_FILE_SIZE = 50 * 1024 * 1024;
